export default __webpack_public_path__ + "static/media/img13.c3c14a80.jpg";